import {
	NormalizedScheduledLeg,
	ScheduledLegView,
	TDriversScheduleResponse,
} from '@mopla/data-models';

export const prepareNormalizedScheduledLegs = (
	driversSchedule: TDriversScheduleResponse
): NormalizedScheduledLeg[] => {
	return driversSchedule.map<NormalizedScheduledLeg>((leg) => {
		if (leg.ref === 'BREAK') {
			return {
				...leg.obj,
				/** Planned start, so a re-predicted break keeps its identity. */
				scheduledLegId: leg.obj.start,
				/** Estimated end: `DONE_BREAK` hides the card, a planned end would hide a running break. */
				state:
					new Date(leg.obj.estimatedEnd).getTime() > Date.now()
						? 'BREAK'
						: 'DONE_BREAK',
				ref: leg.ref,
				driverLegType: leg.driverLegType,
			};
		}

		if (leg.ref === 'VEHICLE_CHECK') {
			return {
				scheduledLegId: leg.obj.assignmentId,
				end: leg.obj.end,
				start: leg.obj.start,
				state: 'VEHICLE_CHECK' as ScheduledLegView['state'],
				licencePlate: leg.obj.licencePlate,
				checkDone: leg.obj.checkDone,
				ref: leg.ref,
				driverLegType: leg.driverLegType,
			};
		}

		return {
			...leg.obj,
			ref: leg.ref,
			driverLegType: leg.driverLegType,
		};
	});
};
